export default __webpack_public_path__ + "static/media/5.a.2.6e44dcff.pdf";